import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { OverlayDefault } from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';



/** Matches AppWrapper main column when Account sidebar (280px) is visible on desktop. */
export const ClosureOverlay = withConfig(theme => styled(OverlayDefault, { label: 'ClosureOverlay' })<{ alreadyClosed?: boolean }>`
    z-index: ${theme.star.zIndexGlobal.base};
    overscroll-behavior: none;
    box-sizing: border-box;
    min-height: 100dvh;
    padding: 0;
  
    @media ${theme.star.mediaQuery.tablet} {
        padding: 0;
    }

    @media ${theme.star.mediaQuery.desktop} {
        ${({ alreadyClosed }): string => alreadyClosed === true ? 'padding-bottom: 16px;' : 'padding: 0 280px 16px 0;'}
    }

    ${({ alreadyClosed }): string => alreadyClosed === true ? 'overflow-x: hidden;' : ''}
`);

export const ClosureStack = styled('div', { label: 'ClosureStack' })`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    min-width: 0;
    width: 100%;
`;

/** Pulls the safer-gambling bar to the top edge of the overlay (cancels overlay padding). */
export const GamblingSafetyTopSlot = styled('div', { label: 'GamblingSafetyTopSlot' })`
    flex-shrink: 0;
    width: 100%;
`;


export const FooterBlock = styled('div', { label: 'FooterBlock' })<{ alreadyClosed?: boolean }>`
    box-sizing: border-box;
    flex-shrink: 0;
    margin-top: 48px;
    width: 100%;

    ${({ alreadyClosed }): string => alreadyClosed === true ? `
        position: absolute;
        bottom: 20px;
        left: 0;
        right: 0;
        margin-top: 0;
        padding: 0 20px;
        width: auto;
    ` : ''}
`;


export const Content = withConfig(theme => styled('div', { label: 'Content' })`
    margin: auto;
    position: relative;
    text-align: center;
    width: 100%;
    max-width: 480px;
    padding: 0 16px;

    @media ${theme.star.mediaQuery.tablet} {
        max-width: 700px;
    }
`);

export const LogoRow = styled('div', { label: 'LogoRow' })`
    display: flex;
    justify-content: center;
    margin-top: 60px;
`;

export const BodySection = styled('div', { label: 'BodySection' })`
    text-align: center;
`;

export const SectionHeading = withConfig(theme => styled('h3', { label: 'SectionHeading' })`
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4;
    margin: 24px 0 0 0;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.regular};
        line-height: 1.3334;
    }
`);

export const PopupHeader = withConfig(theme => styled('h2', { label: 'PopupHeader' })`
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4;
    margin: 24px 0 0 0;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.big};
        line-height: 1.3334;
    }
`);